import { Classes } from '@blueprintjs/core';
import { useApplicationDetail } from '@axo/shared/data-access/hooks';

interface Props {
  id: string;
}

export function HumanReadableID({ id }: Props) {
  const app = useApplicationDetail(id);

  if (app.isLoading) {
    return <span className={Classes.SKELETON}>%app name%</span>;
  }

  return <>{app.data?.HumanReadableID ?? app.data?.ID ?? id}</>;
}
